"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql } from "@opensea/graphql";
import { UnreachableCaseError } from "@opensea/utils";
import { Paginator } from "@/lib/pagination/paginator";
import { useSubscription } from "../use-subscription";
const subscription = graphql(`
  subscription useSalesChartSubscription($slug: String!) {
    collectionChartSalesBySlug(slug: $slug) {
      time
      collectionId
      usd
      native {
        unit
        symbol
      }
      time
      saleKey
    }
  }
`);
class SalesChartPaginator extends Paginator {
  getValues(item, sortBy) {
    switch (sortBy) {
      case "time":
        return [item.time, item.saleKey];
      default:
        throw new UnreachableCaseError(sortBy);
    }
  }
}

// Allow this to grow larger than usual
const salesChartPaginator = new SalesChartPaginator({
  maxItems: 10_000
});
export const useSalesChartSubscription = (collectionSlug, setItems) => {
  const $ = _c(4);
  let t0;
  if ($[0] !== collectionSlug) {
    t0 = {
      query: subscription,
      variables: {
        slug: collectionSlug
      }
    };
    $[0] = collectionSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== setItems) {
    t1 = msg => {
      const item = msg.collectionChartSalesBySlug;
      setItems(prev => {
        const updated = salesChartPaginator.insertInOrder(item, prev, {
          by: "time",
          direction: "ASC"
        }, {
          insertIntoLastPlace: true
        });
        return updated;
      });
    };
    $[2] = setItems;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useSubscription(t0, t1);
};